<!-- Selected Chips -->
<div class="chips-container" *ngIf="selected.length > 0">
  <span class="chip" *ngFor="let item of selected">
    {{ item }}
    <button type="button" class="chip-remove" (click)="remove(item)" [disabled]="disabled" aria-label="Remove {{ item }}">
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z" fill="currentColor"/></svg>
    </button>
  </span>
</div>

<!-- Placeholder -->
<div class="chips-placeholder" *ngIf="selected.length === 0">{{ placeholder }}</div>

<!-- Checkbox List -->
<div class="checkbox-list">
  <label
    *ngFor="let option of options"
    class="checkbox-option"
    [class.disabled]="disabled"
  >
    <input
      type="checkbox"
      [checked]="isSelected(option)"
      (change)="toggle(option)"
      [disabled]="disabled"
    />
    <span class="checkbox-text">{{ option }}</span>
  </label>
</div>
